import React from 'react';

const PadOptionsForm = ({
  padJobSheetsPerPad,
  setPadJobSheetsPerPad,
  padGlueEdge,
  setPadGlueEdge,
}) => {
  return (
    <div className="md:col-span-2 border p-4 rounded bg-gray-50"> {/* Changed to span 2 columns */}
      <h3 className="font-medium mb-3">Pad Options</h3>

      {/* Grid for side-by-side inputs */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
        {/* Sheets Per Pad */}
        <div className="mb-0"> {/* Adjusted margin for grid layout */}
          <label className="block text-sm font-medium mb-1">Sheets per Pad</label>
          <input
            type="number"
            value={padJobSheetsPerPad}
            onChange={(e) => setPadJobSheetsPerPad(Math.max(1, Number(e.target.value)))}
            className="w-full p-2 border rounded"
            min="1"
            placeholder="e.g. 50"
          />
          <p className="text-xs text-gray-500 mt-1">
            Physical sheets in each pad. Double-sided printing still counts as one sheet.
          </p>
        </div>

        {/* Pad Glue Edge */}
        <div className="mb-0"> {/* Adjusted margin for grid layout */}
          <label className="block text-sm font-medium mb-1">Pad Glue Edge</label>
          <select
            value={padGlueEdge}
            onChange={(e) => setPadGlueEdge(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="top">Top</option>
            <option value="left">Left</option>
            <option value="right">Right</option>
            <option value="bottom">Bottom</option>
          </select>
          <p className="text-xs text-gray-500 mt-1">
            Select which edge the pad will be glued on.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PadOptionsForm;
